import React from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import ProductListDetails from "./ProductListDetails";
import useMediaQuery from "@mui/material/useMediaQuery";
import styled from "styled-components";

const ProductsListView = () => {
  const matches = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const productsList = useSelector(
    (state) => state?.allProducts?.productsList || {}
  );

  const { items = [] } = productsList || {};

  

  return (
    <React.Fragment>
      
        <Paper variant="outlined" style={{borderRadius:5,padding:'.5rem .5rem',minHeight:'99vh'}} square>
      
            <div className="productlistcontainer">
             {items?.length > 0 && <ProductListDetails listItems={items} />}
            </div>

        </Paper>

        <style>
          {`
          .productlistcontainer{
          display:grid;
          grid-template-columns: repeat(5, 1fr);
          gap: .7rem;
          }

          @media (max-width: 1200px) {
          .productlistcontainer{
           grid-template-columns: repeat(3, 1fr);}
          }

          @media (max-width: 600px) {
          .productlistcontainer{
           grid-template-columns: repeat(2, 1fr);}
          }
          `}
        </style>
    
    </React.Fragment>
  );
};

export default ProductsListView;
